var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
export class ViewColumnToggleComponent {
    constructor(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
        this.isIn = false;
    }
    ngOnInit() {
        combineLatest(this.chapter$, this.layout$)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe(([chapter, layout]) => {
            this.isIn = layout.column.status === ViewLayoutStatus.Collapse;
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    isVisible() {
        return this.layoutService.isVisible(ViewLayout.ColumnToggle);
    }
    handleToggleClick() {
        this.viewService.toggleColumn();
        this.changeDetectorRef.markForCheck();
    }
}
__decorate([
    Select(ViewState.getLayout),
    __metadata("design:type", Observable)
], ViewColumnToggleComponent.prototype, "layout$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapter),
    __metadata("design:type", Observable)
], ViewColumnToggleComponent.prototype, "chapter$", void 0);
